import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const originalConsoleLog = console.log;
const originalConsoleInfo = console.info;

console.log = (...args) => {
  const message = args.join(' ');
  if (message.includes('Download the React DevTools')) {
    return;
  }
  originalConsoleLog.apply(console, args);
};

console.info = (...args) => {
  const message = args.join(' ');
  if (message.includes('Download the React DevTools')) {
    return;
  }
  originalConsoleInfo.apply(console, args);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

reportWebVitals();
